<template>
    <module-card :nextDisabled="nextDisabled">
        <p>How do you prefer to get notifications?</p>
        <p>This can be changed at any time in “Settings” (top right corner).</p>
        <v-radio-group v-model="notifications">
            <v-radio v-for="(choice, index) in notificationChoices" :key="index" :label="choice.label" :value="choice.value"></v-radio>
        </v-radio-group>
    </module-card>
</template>

<script>
    import { sync, get } from 'vuex-pathify';

    export default {
        computed: {
            notifications: sync('notifications'),
            notificationChoices: get('content@notificationChoices')
        },
        methods: {
            nextDisabled() {
                return !this.notifications;
            }
        }
    };
</script>
